module.exports = __webpack_public_path__ + "static/media/625JettStNW_2018-06-26_135.6c0fb83f.jpg";